import { render } from "./BodyAdventure.vue?vue&type=template&id=6b5e539b"
import script from "./BodyAdventure.vue?vue&type=script&lang=js"
export * from "./BodyAdventure.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/windowOverlay/reportInfo/BodyAdventure.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b5e539b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b5e539b', __exports__)) {
    api.reload('6b5e539b', __exports__)
  }
  
  module.hot.accept("./BodyAdventure.vue?vue&type=template&id=6b5e539b", () => {
    api.rerender('6b5e539b', render)
  })

}


export default __exports__